<template>
  <iColumn
    width="fill"
    gap="small"
    align="center"
    data-test="event-countdown-timer"
  >
    <iText
      font-size="small"
      font-weight="dark"
      variant="subtle"
      text-case="uppercase"
    >
      {{ countdownLabel }}
    </iText>
    <iRow
      v-if="isCounting"
      gap="large"
      width="hug"
      wrap="nowrap"
      vertical-align="top"
    >
      <iStat v-if="segments.days > 0" :value="segments.days" label="days" />
      <iStat :value="segments.hours" label="hours" />
      <iStat :value="segments.minutes" label="minutes" />
      <iStat :value="segments.seconds" label="seconds" />
    </iRow>
    <iText v-else font-size="large" font-weight="dark">
      {{ settledCopy }}
    </iText>
  </iColumn>
</template>

<script>
import { EventCountdownElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-countdown-element-mixin";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import { countdownSegments, describeCountdownState } from "%/dynamic-component-editor/helpers/event-countdown";

export default {
  name: "EventCountdownTimer",
  elementPanelSettings: {
    displayIcon: "mdi:timer-outline",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Countdown",
  },
  extends: EventCountdownElementMixin,
  optionBundles: [
    PositioningOptions,
    new AppearanceOptions(),
    new SpacingOptions(),
    new BackgroundOptions({}, { "background-gradient": true }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    countdownState() {
      return describeCountdownState({
        entity: this.entity,
        now: this.countdownNow,
        secondsUntilStart: this.secondsUntilStart,
        secondsUntilEarlyAccess: this.secondsUntilEarlyAccess,
        hasEarlyAccessWindow: this.hasEarlyAccessWindow,
      });
    },
    isCounting() {
      return this.countdownState.isCounting;
    },
    countdownLabel() {
      return this.countdownState.label;
    },
    settledCopy() {
      return this.countdownState.settledCopy;
    },
    segments() {
      return countdownSegments(this.countdownState.secondsRemaining);
    },
  },
};
</script>
